var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 22.9162C25.1241 24.0013 22.9477 24.0013 18.595 24.0013H13.2856C8.93288 24.0013 6.75653 24.0013 5.21381 22.9162C4.64305 22.5148 4.14661 22.0161 3.74697 21.4428C2.66675 19.893 2.66675 17.7069 2.66675 13.3346C2.66675 8.96233 2.66675 6.77618 3.74697 5.22652C4.14661 4.65318 4.64305 4.1545 5.21381 3.75306C6.75653 2.66797 8.93288 2.66797 13.2856 2.66797",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24V29.3333",
    stroke: "#808191",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 29.332H21.3334",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 2.66797C26.5141 2.66797 27.7711 2.66797 28.5522 3.44902C29.3333 4.23006 29.3333 5.48714 29.3333 8.0013V13.3346C29.3333 15.8488 29.3333 17.1058 28.5522 17.8869C27.7711 18.668 26.5141 18.668 23.9999 18.668H22.6666C20.1525 18.668 18.8954 18.668 18.1143 17.8869C17.3333 17.1058 17.3333 15.8488 17.3333 13.3346V8.0013C17.3333 5.48714 17.3333 4.23006 18.1143 3.44902C18.8954 2.66797 20.1525 2.66797 22.6666 2.66797H23.9999Z",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 15.332H23.3453",
    stroke: "#808191",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreens);
export default __webpack_public_path__ + "static/media/screens.891875357cc4a8ddc010c5dedddcf56a.svg";
export { ForwardRef as ReactComponent };